var multipleBikes = {
    addBike: function () {

        var tabIndex = parseInt(JQ('[data-bike]:last').attr('data-bike'));

        // decide wich bike to display
        function handleBikeDisplay(tabIndex) {
            JQ('.mklr-tools-bike').each(function (index, element) {
                if (parseInt(JQ(element).attr('data-bike')) === tabIndex) {
                    JQ(element).css('display', 'block');
                } else {
                    JQ(element).css('display', 'none');
                }
            });
        }

        // active tab handler
        function changeActiveTab (index) {
            JQ('.bike-tab').each(function (i, e) {
                parseInt(JQ(e).attr('data-tab')) === index ? JQ(e).addClass('active') : JQ(e).removeClass('active');
            });

            // disable delete button for the first bike / tab
            if (index === 0) {
                JQ('[data-del-bike="0"]').css('display', 'none');
            }
        }

        // bike delete handler
        function handleBikeDelete (index) {

            // remove tab button
            JQ('[data-tab="'+ index +'"]').remove();

            JQ('.bike-tab').each(function (i, el) {
                if (i <= 9) {
                    JQ('#add-bike').removeClass('disable-add-bike');
                }

                var newIndex = i + 1;
                JQ(el).text('Bike-' + newIndex);
            });

            // remove bike from global array
            FHRD.bikes = FHRD.bikes.filter(function (bike) {
                return bike.id !== index;
            });

            // remove bike from dom
            JQ('[data-bike="'+ index +'"]').remove();

            // reset active tab to first index
            changeActiveTab(0);

            // show first bike again
            handleBikeDisplay(0);

            // recalculate
            FHRD.recalc();
        }

        // add new index for new bike
        tabIndex++;

        // change active tab to new bike
        changeActiveTab(tabIndex);

        // display delete button
        JQ('.delete-bike').css('display', 'block');

        // add new tab
        JQ('.bike-tab-container').css('display', 'flex').append('<button class="bike-tab active" data-tab="' + tabIndex + '">Bike-' + (tabIndex + 1)  + '</button>');

        // add new bike
        var bikeHTML = `
<div class="box mklr-tools-bike" data-bike="${tabIndex}" id="div_fhrd_risk-${tabIndex}"
        style="margin-bottom: 0;">
    <button class="delete-bike" data-del-bike="${tabIndex}">Fahrrad löschen</button>
    <p class="boxheader">Angaben zum Fahrrad:
    <div class="tab" data-infoHead="Informationen zum Kaufpreis" style="margin-top: 27px;"
            title="Bitte Versicherungssumme für die Fahrradversicherung eingeben. Die Mindestversicherungssumme beträgt 1 €. Die maximale Versicherungssumme beträgt 12.500 €.">
        <div class="col1">
            <label class="toppedform" for="f_fhrd_vs-${tabIndex}" id="l_fhrd_vs-${tabIndex}">Kaufpreis
                (Versicherungssumme):</label>
        </div>
        <div class="col2">
            <input id="f_fhrd_vs-${tabIndex}" min="0" name="fhrd_vs-${tabIndex}" type="number" value="0"/>
        </div>
    </div>
    <div class="tab" data-infoHead="Informationen zur PLZ"
            title="PLZ: Bitte geben Sie hier die fünfstellige Postleitzahl des Wohnorts bzw. des Ortes ein, an dem das Fahrrad am häufigsten genutzt wird.">
        <div class="col1">
            <label class="toppedform" for="f_fhrd_plz-${tabIndex}" id="l_fhrd_plz-${tabIndex}">PLZ:</label>
        </div>
        <div class="col1">
            <input class="priv plz" id="f_fhrd_plz-${tabIndex}" name="fhrd_plz-${tabIndex}"/>
        </div>
    </div>
    <div class="tab" data-infoHead="Informationen zum Fahrradtyp"
            title="Bitte auswählen, ob es sich um ein Fahrrad oder E-Bike/Pedelec handelt.">
        <div class="col1">Fahrradtyp:</div>
        <div class="col2"><span class="yn" style="width:90%;"><input checked="checked" id="f_fhrd_ftype_1-${tabIndex}"
                name="fhrd_ftype-${tabIndex}" type="radio"
                value="1"/><label class="optgroup"
                for="f_fhrd_ftype_1-${tabIndex}">
            Fahrrad</label></span><br/><span class="yn" style="width:90%;"><input id="f_fhrd_ftype_2-${tabIndex}"
                name="fhrd_ftype-${tabIndex}"
                type="radio"
                value="2"/><label class="optgroup"
                for="f_fhrd_ftype_2-${tabIndex}">
            E-Bike / Pedelec</label></span>
            <span class="yn" style="width:90%;"><input id="f_fhrd_ftype_3-${tabIndex}"
                name="fhrd_ftype-${tabIndex}"
                type="radio"
                value="3"/><label class="optgroup"
                for="f_fhrd_ftype_3-${tabIndex}">
            Lastenrad</label></span>
            <span class="yn" style="width:90%;"><input id="f_fhrd_ftype_4-${tabIndex}"
                name="fhrd_ftype-${tabIndex}"
                type="radio"
                value="4"/><label class="optgroup"
                for="f_fhrd_ftype_4-${tabIndex}">
            S-Pedelec</label></span>
            </div>
    </div>
    <div class="tab" data-infoHead="Informationen zum Rahmenmaterial"
            title="Bitte angeben, aus welchem Material der Rahmen des Fahrrads bzw. E-Bikes hergestellt wurde.">
        <div class="col1">Rahmenmaterial:</div>
        <div class="col2"><span class="yn"><input checked="checked" id="f_fhrd_mtrl_1-${tabIndex}"
                name="fhrd_mtrl-${tabIndex}" type="radio" value="1"/><label
                class="optgroup" for="f_fhrd_mtrl_1-${tabIndex}" id="l_fhrd_mtrl_1-${tabIndex}">
            Stahl</label></span><br/><span class="yn"><input id="f_fhrd_mtrl_2-${tabIndex}" name="fhrd_mtrl-${tabIndex}"
                type="radio" value="2"/><label
                class="optgroup" for="f_fhrd_mtrl_2-${tabIndex}" id="l_fhrd_mtrl_2-${tabIndex}">
            Aluminum</label></span><br/><span class="yn" style="width:134%;"><input id="f_fhrd_mtrl_3-${tabIndex}"
                name="fhrd_mtrl-${tabIndex}"
                type="radio"
                value="3"/><label class="optgroup"
                for="f_fhrd_mtrl_3-${tabIndex}"
                id="l_fhrd_mtrl_3-${tabIndex}"
                style="width:60em;">
            Carbon</label></span></div>
    </div>
    <div class="tab" data-infoHead="Informationen zum Kaufdatum" title="Bitte Kaufdatum eingeben.">
        <div class="col1">Kaufdatum:</div>
        <div class="col2"><input class="mprv today fhrd_kauf" id="f_fhrd_kauf-${tabIndex}"
                name="fhrd_kauf-${tabIndex}" style="width:80px;"
                value="${moment().format('DD.MM.YYYY')}"/></div>
    </div>
    <div class="tab" data-infoHead="Informationen zum Baujahr" title="Bitte Baujahr eingeben.">
        <div class="col1">Baujahr:</div>
        <div class="col2"><input class="year" id="f_fhrd_yprd-${tabIndex}" name="fhrd_yprd-${tabIndex}" type="number"
                value="${year}"/></div>
    </div>
    <div class="tab" data-infoHead="Informationen zum Hersteller"
            title="Bitte den Hersteller des Fahrrads bzw. E-Bikes eingeben.">
        <div class="col1"><label class="toppedform" for="f_fhrd_producer-${tabIndex}"
                id="l_fhrd_producer-${tabIndex}">Hersteller des Fahrrads bzw. E-Bikes:</label></div>
        <div class="col1"><input class="priv" id="f_fhrd_producer-${tabIndex}" name="fhrd_producer-${tabIndex}" placeholder="Bitte ergänzen" maxlength="2000"/>
        </div>
    </div>
    <div class="tab" data-infoHead="Informationen zur Modellbezeichnung"
            title="Bitte die Modellbezeichnung des Fahrrads bzw. E-Bikes eingeben.">
        <div class="col1"><label class="toppedform" for="f_fhrd_model-${tabIndex}" id="l_fhrd_model-${tabIndex}">Modellbezeichnung:</label>
        </div>
        <div class="col1"><input class="priv" id="f_fhrd_model-${tabIndex}" name="fhrd_model-${tabIndex}" placeholder="Bitte ergänzen" maxlength="2000"/></div>
    </div>
    <div class="tab lrow" data-infoHead="Informationen zur Rahmennummer"
            title="Bitte die Rahmennummer des Fahrrads bzw. E-Bikes eingeben.">
        <div class="col1"><label class="toppedform" for="f_fhrd_frame-${tabIndex}" id="l_fhrd_frame-${tabIndex}">Rahmennummer:</label>
        </div>
        <div class="col1"><input class="priv" id="f_fhrd_frame-${tabIndex}" name="fhrd_frame-${tabIndex}" placeholder="Bitte ergänzen" maxlength="2000"/></div>
    </div>
</div>`;
        JQ('#mklr-tools-bike-container').append(bikeHTML);
        // attach bike delete handler
        JQ('[data-del-bike]').click(function () {
            handleBikeDelete(parseInt(JQ(this).attr('data-del-bike')));
        });

        // create datepicker
        JQ('#f_fhrd_kauf-' + tabIndex).datepicker(
            {
                defaultDate: '+1d',
                maxDate: '+1w',
                minDate: '-5y',
                showOn: ALL.mobile  ? 'focus' : 'both',
            }
        );

        JQ('#f_fhrd_kauf-' + tabIndex).mask('99.99.9999');

        // add tab change listner
        JQ('[data-tab]').click(function () {
            changeActiveTab(parseInt(JQ(this).attr('data-tab')));
            handleBikeDisplay(parseInt(JQ(this).attr('data-tab')));
        });

        // change active view to new added bike
        handleBikeDisplay(tabIndex);

        // push bike in global array
        FHRD.bikes.push({
            id: tabIndex,
            plz: JQ('#f_fhrd_plz-' + tabIndex + ''),
            vs: JQ('#f_fhrd_vs-' + tabIndex + ''),
            mtrl: 1,
            ftype: 2,
        });


        JQ('.bike-tab').each(function (i, e) {
            if (i >= 9) {
                JQ('#add-bike').addClass('disable-add-bike');
                ALL.showInfo('Es können nicht mehr als 10 Fahrräder versichert werden.');
            } else {
                JQ('#add-bike').removeClass('disable-add-bike');
            }
        });

        // append img icons once again :P
        BC.appendImageIcons();
        JQ('img.infobtn').click(ALL.showInfo);

        // disable "zum Angebot"
        JQ('#b_' + FHRD.type + '_go2datavn').button("option", "disabled", true);
    }
}

JQ(document).ready(function () {
    JQ('#add-bike').click(function () {
        multipleBikes.addBike();
    });
});
